import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2jxqeheay: FaireProductEntity = {
  token: "p_x2jxqeheay",
  type: "product",
  name: "Cocktails & Cards / Seasonal Holiday Card Package",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/570edf28d355a7f2068ae64954bc96f28c5173fffccf1ce45ff9ab7e9dcce7a6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a5dcff95546aa133d05c9716cb932152a63d662f9dd202b67e9ed8798f831c3.jpeg",
    "https://cdn.faire.com/fastly/48a0b6b4c54de9d0e5cf0b05f6de673eb852ab54919565a3acdcba9a1f38cfb5.jpeg",
    "https://cdn.faire.com/fastly/ccfdf03b4d16a143295308dfbb64f3a2e8699b981046edcf83c35db77c7ee16b.jpeg",
    "https://cdn.faire.com/fastly/9f6de13f1557a3f5c04100d8f2c4477cbc9cc9f72d26d6fcecd8f76af572f7d1.jpeg",
    "https://cdn.faire.com/fastly/90020089d0f12fde2466850f6a8381785d3dddaef63bc905c8bf00b6a48c15b6.jpeg",
    "https://cdn.faire.com/fastly/499d51e4bc040f011e91ab8d427788ae9d98860286a1792deab55b3b31e1180d.jpeg",
  ],
  priceDollars: 4.25,
  description:
    "No one wants a card with nothing in it...give them what they want - a cocktail in a card!\n\nThis includes 6 cards per design style - a total of 36 cards. There are 3 flavors of cocktails included in the cards - Pumpkin Spice Chai Martini, S'mores Hot Cocoa, and Hot Toddy.\n\nEach card style will have the same flavor of cocktail in the 6 cards.\nWinter, Winter, Cocktails and It's Beginning to Look A lot Like Cocktails has Pumpkin Spice Chai Martini\nTis the Season for a Cocktail and Have Yourself a Merry Little Cocktail has S'more Hot Cocoa\nNaughty, Nice, Cocktails and Peace, Love and Cocktails has Hot Toddy\n\nDon't forget to order a card display box too!\nhttps://www.faire.com/product/p_5s2us44fkq",
  tags: [],
  msrpDollars: 8.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:07.041Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
